var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./payment-form.j2"] = require( "./payment-form.j2" );
dependencies["./addresses-and-payments/no-payment-message.j2"] = require( "./addresses-and-payments/no-payment-message.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/add-new-payment-section.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"formFocus") && (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"focusValue") != "payment")) {
output += "\n\n<div class=\"o-column o-extra-small--12 o-large--6 c-address-book__payments-header is-focused\" data-qa-payment-header-is-focused>\n\n";
;
}
else {
output += "\n\n<div class=\"o-column o-extra-small--12 o-large--6 c-address-book__payments-header\" data-qa-payment-header>\n\n";
;
}
output += "\n\n    <div class=\"o-row c-address-book__header\">\n\n        <div class=\"o-column o-extra-small--6 u-no-gutters\">\n\n            <h2 class=\"c-address-book__h2\">\n\n                ";
output += runtime.suppressValue((lineno = 16, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-payments",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n            </h2>\n\n        </div>\n\n        <div class=\"o-row o-column o-extra-small--6 c-account__button-new u-no-gutters\">\n\n            <a href=\"#\" class=\"c-account__button-new--link js-add-new-card-payments\" data-cm-element=\"account_payment_create\" data-qa-add-payment-button>\n\n                <span class=\"c-account__button-new--copy\">\n\n                ";
output += runtime.suppressValue((lineno = 28, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-addNewCard",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n                </span>\n\n            </a>\n\n        </div>\n\n    </div>\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"showErrors") && runtime.memberLookup(((lineno = 38, colno = 47, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"location") == "payment-edit-form" && env.getFilter("length").call(context, runtime.memberLookup(((lineno = 38, colno = 105, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"data")) > 0) {
output += "\n\n    ";
if(runtime.memberLookup(((lineno = 40, colno = 19, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"data") == ("ERROR_ACCOUNT_POSTAL_CODE_INVALID_FOR_REGION" || "ERROR_ACCOUNT_REGION_INVALID_FOR_POSTAL_CODE")) {
output += "\n\n        ";
var t_1;
t_1 = (lineno = 42, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_form-error-postal-code-region-mismatch"]));
frame.set("formError", t_1, true);
if(frame.topLevel) {
context.setVariable("formError", t_1);
}
if(frame.topLevel) {
context.addExport("formError", t_1);
}
output += "\n\n    ";
;
}
else {
output += "\n\n        ";
var t_2;
t_2 = runtime.memberLookup(((lineno = 46, colno = 36, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"data");
frame.set("formError", t_2, true);
if(frame.topLevel) {
context.setVariable("formError", t_2);
}
if(frame.topLevel) {
context.addExport("formError", t_2);
}
output += "\n\n    ";
;
}
output += "\n\n    <div class=\"c-form__field has-error\">\n\n        <div class=\"c-form-block\">\n\n            <p class=\"c-form-block__p\" data-qa-error-field=\"DUPLICATE_PAYMENT_FOUND\">\n\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "formError"), env.opts.autoescape);
output += "\n\n            </p>\n\n        </div>\n\n    </div>\n\n    ";
;
}
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"newPayment")) {
output += "\n\n        <div class=\"o-row o-column o-extra-small--12 c-address-form c-address-form__new\">\n\n            ";
env.getTemplate("./payment-form.j2", false, "account/templates/partials/add-new-payment-section.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
output += "\n\n        </div>\n\n    ";
})});
}
output += "\n\n    ";
env.getTemplate("./addresses-and-payments/no-payment-message.j2", false, "account/templates/partials/add-new-payment-section.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/add-new-payment-section.j2"] , dependencies)